var scope_0 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2872350a8f00f9e5d1b99a750717e232.js').default;

var scope_1 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/29994d7285d603b2fb20a6500719f310.js').default;

var scope_2 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/303b3d2fa1abaf7bfb7bc58942fac62c.js').default;

var scope_3 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31a5af51e2bff2dbe6fc6bf72472e3f6.js').default;

var scope_4 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/422d14476f4ece6f399903371dcda574.js').default;

var scope_5 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/442c2533fac7212fc9101694ec69606f.js').default;

var scope_6 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48d8afe81a66772870a15a3f56c4a458.js').default;

var scope_7 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/57c2f01de61a4a46fdce99aa25ecba9a.js').default;

var scope_8 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8e952c6e05997c9e571f026512fcc970.js').default;

var scope_9 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9aa8585b77da922b3c07954a2d12efa1.js').default;

var scope_10 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b0a505447545834f948c13b0fbff0bc3.js').default;

var scope_11 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b305e1a7e86e49af90f60cb361398747.js').default;

var scope_12 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8a0683839bb00452a14b85bce640b46.js').default;

var scope_13 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c1ffd1a0cb2258070d6b98470c0f6073.js').default;

var scope_14 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c95904b44edc31740d480ede5f8bfcc5.js').default;

var scope_15 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cd632dad89291ecfd9eb6d63be7186d6.js').default;

var scope_16 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d39c9bf5664eff7bc11b41774e4dca5f.js').default;

var scope_17 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d3b1eb25bc5bca1c09a48ef60ba15fe4.js').default;

var scope_18 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_19 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee4163f4a93e36e386b98110802bb05f.js').default;

var scope_20 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f10b62f14c92d970172c869324163c4d.js').default;

var scope_21 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f69baf65ff39207674d9f0fe036d79f0.js').default;

var scope_22 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fc5387047f0b01c5baba0197fde3cb94.js').default;

var scope_23 = require('/Users/amahony/Sites/reactberry/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff687cbbd22a60df08684d2fbbc29e76.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19, scope_20, scope_21, scope_22, scope_23);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}